// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21Xux","field":"styles_field__LsYNx","fieldCol":"styles_fieldCol__wSAHQ","diffCol":"styles_diffCol__3aklP","diff":"styles_diff__1gnID"};